export default __webpack_public_path__ + "static/media/05.81dfd385.png";